export const mobileReg = /^1[3-9][0-9]{9}$|^1[3-9]-[0-9]{4}-[0-9]{4}$|^(0\d{2,3}-?)\d{7,8}(-\d*)?$|^[4,8][0-9\-]{9,11}$|^(852-?)[0-9]{8}$/

export const numberReg = /^-?([1-9]\d*\.?\d*|0\.\d*[1-9]\d*|0?\.0+|0)$/

export const bankCardReg = /^[0-9]\d{14,19}$/

/* 固话 */
export const phoneReg = /^((0\d{10,11})|((0\d{2,3}-\d{7,8})))$/

export const emojiReg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g